export default "__VITE_ASSET__DZFFSGjo__"